<ng-container *ngIf="control$ | async"></ng-container>
<ng-container *ngIf="form$ | async"></ng-container>
<div class="app-input-textarea-container">
  <div class="form-field">
    <label *ngIf="label" class="app-label">
      {{ label }}
      <ng-container *ngIf="isRequired">*</ng-container>
      <i

        style="padding-left: 5px"
        tooltipPosition="top"
        pTooltip="{{ tooltip }}"
        *ngIf="tooltip"
        class="fa-solid fa-circle-question text-link-color"
      ></i>
    </label>
    <div class="app-input-textarea-field-wrapper">
      <textarea
        [style.height]="initialHeight"
        [ngClass]="{
          'input-field-error': error && (control.dirty || control.touched)
        }"
        class="app-input-textarea-field"
        pTextarea
        [formControl]="control"
        [placeholder]="placeholder || label || ''"
      ></textarea>
    </div>
  </div>
  <div class="input-error-content-wrapper">
    <span class="input-error-color input input-error-content" *ngIf="error">
      <i class="fa-solid fa-triangle-exclamation"></i>
      {{ errorMessages[error] || "" }}
    </span>
  </div>
</div>